<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Store</em>
				<span class="int_type_no_border mgr_10">
					<select v-model="selected_store_no" class="tbl_select">
						<option v-for="(store, index) in shopify_store_list" :key="index" :value="store.store_no">{{ store.store_name }}</option>
					</select>
				</span>

				<em class="lt_text">As of Date</em>
				<CustomDatePicker v-model="as_of_date" class="mgr_10" />

				<a href="javascript:void(0);" @click="getShopifyOrderForCreate()" class="gray_bt">Created Shopify Order</a>
				<a href="javascript:void(0);" @click="getShopifyOrderForUpdate()" class="gray_bt">Updated Shopify Order</a>
				<a href="javascript:void(0);" @click="getFulfilledSalesOrder()" class="gray_bt">Fulfilled S/O</a>

				<em class="lt_text mgl_15">Fulfillment </em>
				<span class="int_type_no_border mgr_10">
					<select v-model="selected_fulfillment_status" class="tbl_select">
						<option :value="null">ALL</option>
						<option :value="null" disabled>------------------------</option>
						<option v-for="(fulfill, index) in fulfillment_status_list" :key="index" :value="fulfill.code">{{ fulfill.name }}</option>
					</select>
				</span>
				<em class="lt_text">Financial </em>
				<span class="int_type_no_border mgr_10">
					<select v-model="selected_financial_status" class="tbl_select">
						<option :value="null">ALL</option>
						<option :value="null" disabled>------------------------</option>
						<option v-for="(financial, index) in financial_status_list" :key="index" :value="financial.code">{{ financial.name }}</option>
					</select>
				</span>

				<a href="javascript:void(0);" @click="filterShopifyOrder()" class="gray_bt">filter</a>
			</div>
		</div>

		<template v-if="mode !== 'FULFILL'">
			<div class="half_tbl_box" v-if="invoice_list.length > 0">
				<div class="left_big_tbl">
					<table class="list_tbl">
						<thead>
							<tr>
								<th style="width: 80px;">SO Date</th>
								<template v-if="mode === 'CRT'">
									<th style="width: 110px;">Shipping</th>
									<th style="width: 110px;">Billing</th>
								</template>
								<template v-else-if="mode === 'UPD'">
									<th style="width: 110px;">SO No.</th>
									<th style="width: 110px;">Status</th>
								</template>
								<th style="width: 60px;">Order No.</th>
								<th>Customer ID</th>
								<th style="width: 110px;">Payment Term</th>
								<th style="width: 110px;">Fulfill Status</th>
								<th style="width: 110px;">Financial Status</th>
								<th style="width: 65px;">Tot.Price</th>
								<th style="width: 65px;">Tot.Qty</th>
								<th style="width: 80px;"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(inv, index) in display_invoice_list" :key="index" @click="selectInvoice(inv)" style="cursor: pointer;" :class="{ on: selected_invoice_id === inv.id }">
								<td>{{ convertDateFormat(inv.createdAt) }}</td>
								<template v-if="mode === 'CRT'">
									<td>
										<span v-if="inv.shippingAddress">{{ inv.shippingAddress.name }}</span>
									</td>
									<td>
										<span v-if="inv.billingAddress">{{ inv.billingAddress.name }}</span>
									</td>
								</template>
								<template v-else-if="mode === 'UPD'">
									<td>
										<span v-if="inv.original_order">{{ inv.original_order.so_dn }}</span>
									</td>
									<td>
										<span v-if="inv.original_order">{{ inv.original_order.status_code }}</span>
									</td>
								</template>
								<td>{{ inv.name }}</td>
								<td :title="inv.customer ? inv.customer.id : ''">
									<span v-if="inv.customer">{{ splitShopifyCustomerId(inv.customer.id) }}</span>
								</td>
								<td>
									<span v-if="inv.paymentTerms">{{ inv.paymentTerms.paymentTermsName }}</span>
								</td>
								<td>{{ inv.displayFulfillmentStatus }}</td>
								<td>{{ inv.displayFinancialStatus }}</td>
								<td class="al_right">
									<span v-if="inv.currentSubtotalPriceSet && inv.currentSubtotalPriceSet.presentmentMoney">{{ inv.currentSubtotalPriceSet.presentmentMoney.amount | toCurrency }}</span>
								</td>
								<td class="al_right">
									{{ inv.currentSubtotalLineItemsQuantity | commaSeparated }}
								</td>
								<td>
									<a v-if="mode === 'CRT' && !inv.cancelReason" href="javascript:void(0);" class="gray_bt" @click="processToMakeInvoice(inv)">{{ mode }}</a>
									<a v-if="mode === 'UPD' && inv.original_order && inv.original_order.status_code === 'O'" href="javascript:void(0);" class="gray_bt" @click="updateInvoice(inv)">{{ mode }}</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="right_small_tbl">
					<table class="list_tbl">
						<colgroup>
							<col />
							<col style="width: 70px;" />
							<col style="width: 70px;" />
							<col style="width: 70px;" />
						</colgroup>
						<thead>
							<tr>
								<th>Name</th>
								<th>Qty.</th>
								<th>Price</th>
								<th>Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in invoice_items" :key="index">
								<td>{{ item.name }}</td>
								<td class="al_right">{{ item.currentQuantity | commaSeparated }}</td>
								<td v-if="item.discountedUnitPriceSet" class="al_right">
									<span v-if="item.discountedUnitPriceSet.presentmentMoney">{{ item.discountedUnitPriceSet.presentmentMoney.amount | toCurrency }}</span>
								</td>
								<td v-if="item.discountedUnitPriceSet" class="al_right">
									<span v-if="item.discountedUnitPriceSet.presentmentMoney">{{ (item.discountedUnitPriceSet.presentmentMoney.amount * item.currentQuantity) | toCurrency }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</template>
		<template v-else>
			<table v-if="invoice_list.length > 0" class="list_tbl">
				<thead>
					<tr>
						<th style="width: 80px;">SO Date</th>
						<th style="width: 120px;">SO No.</th>
						<th style="width: 120px;">Inv No.</th>
						<th style="width: 100px;">Ship To</th>
						<th style="width: 100px;">Bill To</th>
						<th>Shopify Display Name</th>
						<th style="width: 100px;">Shipped Qty.</th>
						<th style="width: 100px;">Shipped Amt.</th>
						<th style="width: 100px;">Shipping Charge</th>
						<th style="width: 100px;">Inv Amt.</th>
						<th style="width: 80px;"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(inv, index) in display_invoice_list" :key="index">
						<td class="al_center">{{ inv.so_date }}</td>
						<td class="al_center">{{ inv.so_dn }}</td>
						<td class="al_center">{{ inv.invoice_dn }}</td>
						<td class="al_center">{{ inv.ship_to_code }}</td>
						<td class="al_center">{{ inv.bill_to_code }}</td>
						<td class="al_center">{{ inv.program_order_dn }}</td>
						<td>{{ inv.total_shipped_quantity | commaSeparated }}</td>
						<td>{{ inv.total_shipped_amount | toCurrency }}</td>
						<td>{{ inv.shipping_charge | toCurrency }}</td>
						<td>{{ inv.invoice_amount | toCurrency }}</td>
						<td>
							<a href="javascript:void(0);" class="gray_bt" @click="updateShopifyOrderInInvoice(inv.order_no)">FULFILL</a>
						</td>
					</tr>
				</tbody>
			</table>
		</template>

		<ShopifyCustomer v-if="show_shopify_customer" :store_no="selected_store_no" :shopify_customer="shopify_customer" @emitCustomer="setCustomer" @close="closeShopifyCustomer()" />
	</div>
</template>

<script>
import { convertYMDToMDY, convertMDYToYMD, daysAgo, isDate } from '@/utils/date.js';
import {
	apiGetShopifyOrderForCreate,
	apiGetShopifyOrderForUpdate,
	apiGetFulfilledSalesOrder,
	apiUpdateShopifyOrderInInvoice,
	apiInsertSalesOrder,
	apiUpdateSalesOrder,
	apiGetCustomerByThirdPartyCustomerId,
} from '@/api/shopify/shopify_order.js';
import { apiGetShopifyStoreList, apiSetThirdPartyStoreSetting } from '@/api/shopify/shopify_common.js';
import { converShopifyOrderToSOForCreate, converShopifyOrderToSOForUpdate } from '@/views/shopify/shopify.js';

import CustomDatePicker from '@/components/common/CustomDatePicker';
import ShopifyCustomer from '@/views/shopify/ShopifyCustomer.vue';

export default {
	data: () => ({
		shopify_store_list: [],
		selected_store_no: null,

		invoice_list: [],
		invoice_items: [],
		display_invoice_list: [],

		selected_invoice_id: null,
		mode: null,
		as_of_date: null,

		show_shopify_customer: false,
		shopify_customer: null,
		temp_shopify_order: null,

		financial_status_list: [
			{ code: 'PAID', name: 'PAID' },
			{ code: 'AUTHORIZED', name: 'AUTHORIZED' },
			{ code: 'PARTIALLY_PAID', name: 'PARTIALLY PAID' },
			{ code: 'PARTIALLY_REFUNDED', name: 'PARTIALLY REFUNDED' },
			{ code: 'PENDING', name: 'PENDING' },
			{ code: 'REFUNDED', name: 'REFUNDED' },
			{ code: 'VOIDED', name: 'VOIDED' },
			{ code: 'EXPIRED', name: 'EXPIRED' },
		],
		fulfillment_status_list: [
			{ code: 'FULFILLED', name: 'FULFILLED' },
			{ code: 'UNFULFILLED', name: 'UNFULFILLED' },
			{ code: 'ETC', name: 'ETC' },
		],
		original_fulfillment_status_list: ['FULFILLED', 'IN_PROGRESS', 'ON_HOLD', 'OPEN', 'PARTIALLY_FULFILLED', 'PENDING_FULFILLMENT', 'RESTOCKED', 'SCHEDULED', 'UNFULFILLED'],
		original_financial_status_list: ['PAID', 'AUTHORIZED', 'PARTIALLY_PAID', 'PARTIALLY_REFUNDED', 'PENDING', 'REFUNDED', 'VOIDED', 'EXPIRED'],
		selected_financial_status: null,
		selected_fulfillment_status: null,
	}),
	components: {
		CustomDatePicker,
		ShopifyCustomer,
	},
	watch: {
		selected_store_no: {
			handler() {
				this.setThirdPartyStoreSetting();
			},
		},
	},
	methods: {
		filterShopifyOrder() {
			// 이 메서드는 Created/Updated Shopify S/O화면에서의 Filter 기능이므로 Fulfilled S/O화면에서는 작동 안함.
			// ** Fulfilled S/O화면과 Created/Updated Shopify S/O화면은 원칙적으로 분리되어야 하지만, 작업 예정 없음.
			if (this.mode === 'FULFILL') return;

			let order_list = null;
			if (!this.selected_fulfillment_status) {
				order_list = [...this.invoice_list];
			} else if (this.original_fulfillment_status_list.indexOf(this.selected_fulfillment_status) < 0) {
				order_list = this.invoice_list.filter(inv => !this.fulfillment_status_list.some(ff => ff.code === inv.displayFulfillmentStatus));
			} else {
				order_list = this.invoice_list.filter(inv => inv.displayFulfillmentStatus === this.selected_fulfillment_status);
			}

			if (!this.selected_financial_status) {
				this.display_invoice_list = [...order_list];
			} else if (this.original_financial_status_list.indexOf(this.selected_financial_status) < 0) {
				this.display_invoice_list = order_list.filter(inv => !this.financial_status_list.some(fc => fc.code === inv.displayFinancialStatus));
			} else {
				this.display_invoice_list = order_list.filter(inv => inv.displayFinancialStatus === this.selected_financial_status);
			}

			if (this.display_invoice_list.length) this.selectInvoice(this.display_invoice_list[0]);
			else this.deselectInvoice();
		},
		setDefaultStatusFilter() {
			this.selected_fulfillment_status = 'UNFULFILLED';
			this.selected_financial_status = 'PAID';
		},
		async getShopifyOrderForCreate() {
			if (!this.as_of_date || !isDate(this.as_of_date)) {
				this.$toast.error('Please, Input As of Date.');
				return;
			}
			this.mode = 'CRT';

			const { data } = await apiGetShopifyOrderForCreate(this.selected_store_no, convertMDYToYMD(this.as_of_date));
			if (data.result === 'FAIL') {
				this.$toast.error(data.msg);
				return;
			}
			this.invoice_list = Array.isArray(data.data) ? data.data : [];
			if (!this.invoice_list.length) {
				this.$toast.error('No Created Shopify Order Data.');
			} else {
				this.filterShopifyOrder();
			}
			// console.log(JSON.stringify(this.invoice_list, null, 4));
		},
		async getShopifyOrderForUpdate() {
			if (!this.as_of_date || !isDate(this.as_of_date)) {
				this.$toast.error('Please, Input As of Date.');
				return;
			}
			this.mode = 'UPD';

			const { data } = await apiGetShopifyOrderForUpdate(this.selected_store_no, convertMDYToYMD(this.as_of_date));
			if (data.result === 'FAIL') {
				this.$toast.error(data.msg);
				return;
			}
			this.invoice_list = Array.isArray(data.data) ? data.data : [];
			if (!this.invoice_list.length) {
				this.$toast.error('No Updated Shopify Order Data.');
			} else {
				this.filterShopifyOrder();
			}
			// console.log(JSON.stringify(this.invoice_list, null, 4));
		},
		async getFulfilledSalesOrder() {
			if (!this.as_of_date || !isDate(this.as_of_date)) {
				this.$toast.error('Please, Input As of Date.');
				return;
			}
			this.mode = 'FULFILL';

			const { data } = await apiGetFulfilledSalesOrder(this.selected_store_no, convertMDYToYMD(this.as_of_date));
			this.invoice_list = Array.isArray(data) ? data : [];
			this.display_invoice_list = [...this.invoice_list];
		},
		async updateShopifyOrderInInvoice(order_no) {
			const { data } = await apiUpdateShopifyOrderInInvoice(order_no);
			if (data.result === 'FAIL') this.$alertify.alert(data.msg);
			else this.$toast.success("UPDATE SHOPIFY ORDER's STATUS\r\nAND SHIPPING CHARGE INFO.");

			this.getFulfilledSalesOrder();
		},

		async processToMakeInvoice(inv) {
			if (!inv.customer) {
				this.$toast.error('Customer Info. Required');
				return;
			}

			const customer = await this.getCustomerByThirdPartyCustomerId(inv.customer.id);
			if (!customer) {
				this.temp_shopify_order = inv;
				this.shopify_customer = inv.customer;
				this.show_shopify_customer = true;
			} else {
				this.insertInvoice(inv, customer);
			}
		},
		async getCustomerByThirdPartyCustomerId(program_customer_id) {
			const { data } = await apiGetCustomerByThirdPartyCustomerId(this.selected_store_no, program_customer_id);
			return data;
		},
		async setCustomer(customer) {
			await this.insertInvoice(this.temp_shopify_order, customer);
			this.closeShopifyCustomer();
		},
		closeShopifyCustomer() {
			this.temp_shopify_order = null;
			this.shopify_customer = null;
			this.show_shopify_customer = false;
		},
		async insertInvoice(inv, customer) {
			const basic_info = {
				ship_to_code: customer.code,
				bill_to_code: customer.code,
				sales_group_code: customer.sales_group_code,
				payment_term_code: customer.payment_term_code,
				ship_charge_code: customer.ship_charge_code,
				delivery_type_code: customer.delivery_type_code,
			};
			const so = await converShopifyOrderToSOForCreate(inv, basic_info);
			if (!so.data) {
				this.$alertify.alert(so.msg);
				return;
			}

			so.data.third_party_order = {
				store_no: this.selected_store_no,
				cust_no: customer.cust_no,
				program_order_id: inv.id,
				program_order_dn: inv.name,
				program_crt_dt: this.convertDateTime(inv.createdAt),
				program_upd_dt: this.convertDateTime(inv.updatedAt),
				process_type: 'CRT_SO',
			};

			// Sales Order Insert
			const insert_so = await this.insertSalesOrder(so.data);
			if (!insert_so) this.$toast.success('Failed to Make Sales Order.');

			this.removeOrderFromList(inv);
			this.$toast.success('Success to Make Sales Order.');
		},
		async updateInvoice(inv) {
			// Shopify Order와의 Code데이터 Mapping 이슈
			// original_order basic_info의 관계를 어떻게 정리할 것인지 논의 예정
			const original_order = inv.original_order;
			const basic_info = {
				ship_to_code: original_order.ship_to_code,
				bill_to_code: original_order.bill_to_code,
				sales_group_code: original_order.sales_group_code, // 논의 예정
				payment_term_code: original_order.payment_term_code, // 논의 예정
				ship_charge_code: original_order.ship_charge_code, // 논의 예정
				delivery_type_code: original_order.delivery_type_code, // 논의 예정
			};

			const so = await converShopifyOrderToSOForUpdate(inv, basic_info);
			if (!so.data) {
				this.$alertify.alert(so.msg);
				return;
			}

			so.data.third_party_order = {
				invoice_no: original_order.invoice_no,
				order_no: original_order.order_no,
				program_order_id: inv.id,
				program_crt_dt: this.convertDateTime(inv.createdAt),
				program_upd_dt: this.convertDateTime(inv.updatedAt),
				process_type: 'UPD_SO',
			};
			so.data.status_changed_yn = so.status_code !== 'O' ? 'Y' : 'N';
			const update_so = await this.updateSalesOrder(so.data);
			if (!update_so) this.$toast.success('Failed to Update Sales Order.');

			this.removeOrderFromList(inv);
			this.$toast.success('Success to Update Sales Order.');
		},
		async insertSalesOrder(so) {
			const { data } = await apiInsertSalesOrder(so);
			if (data && data.result === 'SUCCESS') return true;
			else return false;
		},
		async updateSalesOrder(so) {
			const { data } = await apiUpdateSalesOrder(so);
			if (data && data.result === 'SUCCESS') return true;
			else return false;
		},
		convertDateFormat(dateTime) {
			if (!dateTime) return null;
			return convertYMDToMDY(dateTime.split('T')[0], '-');
		},
		convertDateTime(dateTime) {
			if (typeof dateTime !== 'string') return null;

			const t_idx = dateTime.indexOf('T');
			const z_idx = dateTime.indexOf('Z');
			if (t_idx > -1 && z_idx > -1) return dateTime.substring(0, t_idx) + ' ' + dateTime.substring(t_idx + 1, z_idx);
			else null;
		},
		selectInvoice(inv) {
			// console.log(JSON.stringify(inv, null, 4));
			this.selected_invoice_id = inv.id;
			this.invoice_items = inv.lineItems || [];
		},
		deselectInvoice() {
			this.selected_invoice_id = null;
			this.invoice_items = [];
		},
		splitShopifyCustomerId(customerId) {
			if (typeof customerId !== 'string') return null;
			return customerId.substring(customerId.lastIndexOf('/') + 1);
		},
		removeOrderFromList(inv) {
			this.spliceByEqualProp(this.display_invoice_list, inv, 'id');
			this.spliceByEqualProp(this.invoice_list, inv, 'id');
			this.deselectInvoice();
		},
		spliceByEqualProp(list, obj, prop) {
			if (!Array.isArray(list)) return;
			if (typeof obj !== 'object') return;
			if (typeof prop !== 'string') return;

			let idx = list.findIndex(el => el[prop] === obj[prop]);
			if (idx > -1) list.splice(idx, 1);
		},
		async setThirdPartyStoreSetting() {
			const { data } = await apiSetThirdPartyStoreSetting(this.selected_store_no);
			if (data.result !== 'SUCCESS') {
				this.$toast.error('Network Error.');
			}
		},
		async getShopifyStoreList() {
			const { data } = await apiGetShopifyStoreList();
			this.shopify_store_list = data || [];
			if (this.shopify_store_list.length > 0) this.selected_store_no = this.shopify_store_list[0].store_no;
		},
		async connectWithShopify() {
			// Server에서 query 생성
			//let query = '{ "query": "{ products(first: 10) { edges { node { title id handle }  } pageInfo { hasNextPage } } }" }';
			// 문자열을 나타내는 따옴표는 [ \\" ]로 표시
			// query = '{ "query": "{ product(id: \\"gid://shopify/Product/8051540951333\\") { id title handle description onlineStoreUrl } }" }';
			// ShopifyQL
			// query =
			// 	'{ "query": "query { shopifyqlQuery(query: \\"FROM orders SHOW sum(net_sales) AS monthly_net_sales GROUP BY month SINCE -3m ORDER BY month\\") { __typename ... on TableResponse { tableData { unformattedData rowData columns { name dataType displayName } } } parseErrors { code message range { start { line character } end { line character } } } } }" }';
		},
	},
	created() {
		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_shopify_order');
		this.$store.commit('setSubTitle', 'Sales -> Shopify');

		this.as_of_date = daysAgo(6);
		this.setDefaultStatusFilter();
		this.getShopifyStoreList();
	},
};
</script>

<style scoped></style>
